module.exports = __webpack_public_path__ + "img/backstage.f7668292.png";